module.exports = __webpack_public_path__ + "static/img/利害關係人溝通02EN.d85d9fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/利害關係人溝通02EN.jpg
// module id = ZHWs
// module chunks = 1